import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import Navbar from '../../../components/navbar/navbar'

import {
  ArrowRight,
  ArrowsCounterClockwise,
  ArrowsLeftRight,
  Eye,
  MagnifyingGlass,
} from '@phosphor-icons/react'
import { useEffect, useMemo, useState } from 'react'
import { CaretDown, CaretUp } from 'react-bootstrap-icons'
import ReactPaginate from 'react-paginate'
import { toast } from 'react-toastify'
import { Center } from '../../../components/Center'
import { CustomButton } from '../../../components/CustomButton'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { SquaresAddresses } from '../../../components/SquaresAddresses'
import { useOrderTable } from '../../../hooks/useOrderTable'
import WmsAddressService from '../../../services/database/WmsAddressService'
import WmsPickingService from '../../../services/database/WmsPickingService'
import { getValue } from '../../../utils/getValue'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { ModalViewProducts } from './ModalViewProducts'
import {
  Buttons,
  CardSituation,
  Container,
  Content,
  Group,
  PickingCard,
  Title,
} from './styles'

export function WMSTransferenciaPicking() {
  const [searchSku, setSearchSku] = useState('')
  const [isSearchLoading, setIsSearchLoading] = useState(false)

  const [modalViewProducts, setModalViewProducts] = useState({
    codendereco: null,
    open: false,
  })

  const [origin, setOrigin] = useState(null)
  const [destination, setDestination] = useState(null)

  const [addresses, setAddresses] = useState([])
  const [isAddressesPickingLoading, setIsAddressesPickingLoading] =
    useState(true)
  const [isReloadDataLoading, setIsReloadDataLoading] = useState(false)

  //? search
  const [addressSearch, setAddressSearch] = useState({
    codendereco: '',
    deposito: '',
    rua: '',
    predio: '',
    nivel: '',
    apto: '',
    situacao: '',
  })

  const [isTransferLoading, setIsTransferLoading] = useState(false)
  const [isInvertLoading, setIsInvertLoading] = useState(false)

  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)

  const endOffset = itemOffset + 10

  const filteredAddresses = useMemo(() => {
    let result = addresses

    if (addressSearch.situacao) {
      result = result.filter((address) =>
        String(address.situacao).includes(addressSearch.situacao),
      )
    }

    if (addressSearch.codendereco) {
      result = result.filter((address) =>
        String(address.codendereco).includes(addressSearch.codendereco),
      )
    }

    if (addressSearch.deposito) {
      result = result.filter(
        (address) => address.deposito == addressSearch.deposito,
      )
    }

    if (addressSearch.rua) {
      result = result.filter((address) => address.rua == addressSearch.rua)
    }

    if (addressSearch.predio) {
      result = result.filter(
        (address) => address.predio == addressSearch.predio,
      )
    }

    if (addressSearch.nivel) {
      result = result.filter((address) => address.nivel == addressSearch.nivel)
    }

    if (addressSearch.apto) {
      result = result.filter((address) => address.apto == addressSearch.apto)
    }

    if (addressSearch.situacao) {
      result = result.filter((address) =>
        String(address.situacao).includes(addressSearch.situacao),
      )
    }

    setPageCount(Math.ceil(result.length / 10))

    return result.slice(itemOffset, endOffset)
  }, [
    addressSearch.apto,
    addressSearch.codendereco,
    addressSearch.deposito,
    addressSearch.nivel,
    addressSearch.predio,
    addressSearch.rua,
    addressSearch.situacao,
    addresses,
    endOffset,
    itemOffset,
  ])

  const {
    check,
    handleOrganize,
    sortedArray: sortedAddresses,
  } = useOrderTable(filteredAddresses, 'codendereco', 'asc')

  function handlePageClick(event) {
    const newOffset = (event.selected * 10) % addresses.length

    setItemOffset(newOffset)
  }

  function handleChangeSearchAddress(e) {
    const { name, value } = e.target

    setAddressSearch((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleSearchProduct(sku) {
    try {
      setIsSearchLoading(true)

      const data = await WmsPickingService.getBySKU(searchSku || sku)

      if (!data) {
        setOrigin(null)
        return toast.warn('Produto sem picking!')
      }

      setOrigin(data)
    } catch (err) {
      setOrigin(null)
      sendErrorApiMessage(err, 'Não foi possível buscar o produto!')
    } finally {
      setIsSearchLoading(false)
    }
  }

  async function getPickings() {
    try {
      setIsAddressesPickingLoading(true)

      const data = await WmsAddressService.getBySearch({
        tipoender: 'AP',
      })

      setAddresses(data)
      setDestination(null)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o produto!')
    } finally {
      setIsAddressesPickingLoading(false)
    }
  }

  async function handleTransferPicking() {
    if (destination?.situacao !== 'L') {
      return toast.warn(
        'O endereço de destino deve obrigatoriamente estar livre para ser transferido, se necessário, inverta os pickings',
      )
    }

    if (origin?.codendereco == destination?.codendereco) {
      return toast.warn(
        'Endereço de origem deve ser diferente do endereço de destino',
      )
    }

    try {
      setIsTransferLoading(true)

      await WmsPickingService.transfer({
        sku: origin?.sku,
        origin: origin?.codendereco,
        destination: destination?.codendereco,
      })

      toast.success('A OS para transferência de picking foi criada com sucesso')

      await handleReloadData({ noMessage: false })
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Erro ao realizar a transferência entre pickings',
      )
    } finally {
      setIsTransferLoading(false)
    }
  }

  async function handleInvertPicking() {
    if (
      destination?.situacao !== 'O' ||
      origin?.codendereco == destination?.codendereco
    ) {
      return toast.warn(
        'Para inverter, o endereço de destino deve ser ocupado e diferente do endereço de origem',
      )
    }

    try {
      setIsInvertLoading(true)

      await WmsPickingService.invert({
        origin: origin?.codendereco,
        destination: destination?.codendereco,
      })

      toast.success('A OS para inversão de picking foi criada com sucesso')

      await handleReloadData({ noMessage: false })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao realizar a inversão entre pickings')
    } finally {
      setIsInvertLoading(false)
    }
  }

  async function handleReloadData({ noMessage = true }) {
    try {
      setIsReloadDataLoading(true)

      await handleSearchProduct(origin?.sku)
      await getPickings()

      if (!noMessage) {
        return
      }

      return toast.info('Informações recarregadas!')
    } finally {
      setIsReloadDataLoading(false)
    }
  }

  useEffect(() => {
    getPickings()
  }, [])

  return (
    <>
      <Container>
        <Navbar />

        <Content>
          <Title>Transferência de Picking</Title>

          <Row className="p-4">
            <Col>
              <p>Origem</p>

              <Group>
                <Form.Control
                  placeholder="Digite o SKU do produto..."
                  value={searchSku}
                  onChange={(e) => setSearchSku(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && searchSku) {
                      handleSearchProduct()
                    }
                  }}
                />

                <OverlayTrigger overlay={<Tooltip>Buscar</Tooltip>}>
                  <CustomButton
                    isDisabled={!searchSku}
                    onClick={handleSearchProduct}
                    isLoading={isSearchLoading}
                    styles={{
                      minHeight: 38,
                    }}
                  >
                    <MagnifyingGlass />
                  </CustomButton>
                </OverlayTrigger>

                <OverlayTrigger
                  overlay={<Tooltip>Recarregar Informações</Tooltip>}
                >
                  <CustomButton
                    isDisabled={!searchSku && !origin?.sku}
                    onClick={handleReloadData}
                    isLoading={isReloadDataLoading}
                    styles={{
                      minHeight: 38,
                    }}
                  >
                    <ArrowsCounterClockwise />
                  </CustomButton>
                </OverlayTrigger>
              </Group>

              {origin?.codendereco && (
                <PickingCard>
                  <SquaresAddresses
                    codendereco={origin.codendereco}
                    rua={origin.rua}
                    predio={origin.predio}
                    nivel={getValue(origin.nivel)}
                    apto={origin.apto}
                    qt={getValue(origin.qt)}
                  />
                </PickingCard>
              )}
            </Col>

            <Col>
              <p>Destino</p>

              {isAddressesPickingLoading ? (
                <Center>
                  <CustomSpinner size={25} />
                  <p
                    style={{
                      all: 'unset',
                    }}
                  >
                    Carregando endereços de picking...
                  </p>
                </Center>
              ) : (
                <>
                  <Row className="mt-4">
                    <Col>
                      <Form.Label>Cód. End.</Form.Label>

                      <Form.Control
                        name="codendereco"
                        value={addressSearch.codendereco}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Dep.</Form.Label>

                      <Form.Control
                        name="deposito"
                        value={addressSearch.deposito}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Rua</Form.Label>

                      <Form.Control
                        name="rua"
                        value={addressSearch.rua}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Préd.</Form.Label>

                      <Form.Control
                        name="predio"
                        value={addressSearch.predio}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col>
                      <Form.Label>Nvl</Form.Label>

                      <Form.Control
                        name="nivel"
                        value={addressSearch.nivel}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Apto</Form.Label>

                      <Form.Control
                        name="apto"
                        value={addressSearch.apto}
                        onChange={handleChangeSearchAddress}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Situação</Form.Label>
                      <Form.Select
                        name="situacao"
                        value={addressSearch.situacao}
                        onChange={handleChangeSearchAddress}
                      >
                        <option value="">Todos</option>
                        <option value="L">Livre</option>
                        <option value="O">Ocupado</option>
                      </Form.Select>
                    </Col>
                  </Row>

                  {filteredAddresses.length > 0 && (
                    <>
                      <Table>
                        <thead>
                          <tr>
                            <th></th>

                            <th onClick={() => handleOrganize('codendereco')}>
                              <span>Cód. Endereço</span>
                              <CaretUp color={check('codendereco', 'asc')} />
                              <CaretDown color={check('codendereco', 'desc')} />
                            </th>

                            <th onClick={() => handleOrganize('deposito')}>
                              <span>Dep.</span>
                              <CaretUp color={check('deposito', 'asc')} />
                              <CaretDown color={check('deposito', 'desc')} />
                            </th>

                            <th onClick={() => handleOrganize('rua')}>
                              <span>Rua</span>
                              <CaretUp color={check('rua', 'asc')} />
                              <CaretDown color={check('rua', 'desc')} />
                            </th>

                            <th onClick={() => handleOrganize('predio')}>
                              <span>Préd.</span>
                              <CaretUp color={check('predio', 'asc')} />
                              <CaretDown color={check('predio', 'desc')} />
                            </th>

                            <th onClick={() => handleOrganize('nivel')}>
                              <span>Nvl</span>
                              <CaretUp color={check('nivel', 'asc')} />
                              <CaretDown color={check('nivel', 'desc')} />
                            </th>

                            <th onClick={() => handleOrganize('apto')}>
                              <span>Apto</span>
                              <CaretUp color={check('apto', 'asc')} />
                              <CaretDown color={check('apto', 'desc')} />
                            </th>

                            <th>Sit.</th>
                            <th>Ações</th>
                          </tr>
                        </thead>

                        <tbody>
                          {sortedAddresses.map((address) => (
                            <tr key={address.codendereco}>
                              <td>
                                <Form.Check
                                  checked={
                                    destination?.codendereco ==
                                    address.codendereco
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setDestination(address)
                                    } else {
                                      setDestination(null)
                                    }
                                  }}
                                />
                              </td>
                              <td>{address.codendereco}</td>
                              <td>{address.deposito}</td>
                              <td>{address.rua}</td>
                              <td>{address.predio}</td>
                              <td>{address.nivel}</td>
                              <td>{address.apto}</td>
                              <td>
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip>
                                      {address.situacao == 'L'
                                        ? 'Livre'
                                        : 'Ocupado'}
                                    </Tooltip>
                                  }
                                >
                                  <CardSituation
                                    color={
                                      address.situacao == 'L'
                                        ? '#28b463'
                                        : '#f02727'
                                    }
                                  >
                                    {address.situacao}
                                  </CardSituation>
                                </OverlayTrigger>
                              </td>
                              <td>
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip>
                                      {address.situacao === 'L'
                                        ? ''
                                        : 'Ver Produtos'}
                                    </Tooltip>
                                  }
                                >
                                  <CustomButton
                                    isDisabled={address.situacao === 'L'}
                                    onClick={() =>
                                      setModalViewProducts({
                                        codendereco: address.codendereco,
                                        open: true,
                                      })
                                    }
                                  >
                                    <Eye weight="fill" />
                                  </CustomButton>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <ReactPaginate
                        breakLabel="..."
                        nextLabel="Próxima"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="Anterior"
                        renderOnZeroPageCount={null}
                        containerClassName="pagination"
                        activeClassName="active"
                      />
                    </>
                  )}
                </>
              )}
            </Col>
          </Row>

          <Buttons>
            <OverlayTrigger
              overlay={
                <Tooltip>
                  Transfere quantidade do picking X (Origem) para o Y (Destino)
                </Tooltip>
              }
            >
              <CustomButton
                title="Transferir"
                isDisabled={!origin || !destination}
                onClick={handleTransferPicking}
                isLoading={isTransferLoading}
                isLoadingText="Transferindo..."
              >
                <ArrowRight />
              </CustomButton>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>
                  Inverte as quantidades, onde a quantidade do picking X
                  (Origem) vai para o Y (Destino) e vice-versa
                </Tooltip>
              }
            >
              <CustomButton
                title="Inverter"
                isDisabled={!origin || !destination}
                onClick={handleInvertPicking}
                isLoading={isInvertLoading}
                isLoadingText="Invertendo..."
              >
                <ArrowsLeftRight />
              </CustomButton>
            </OverlayTrigger>
          </Buttons>
        </Content>
      </Container>

      {modalViewProducts.open && (
        <ModalViewProducts
          isOpen={modalViewProducts.open}
          onClose={() =>
            setModalViewProducts({
              codendereco: null,
              open: false,
            })
          }
          codendereco={modalViewProducts.codendereco}
        />
      )}
    </>
  )
}
